import React from "react";
import MenuCardDescription, {
  MenuCardDescriptionProps,
} from "./MenuCardDescription";
import ImageLightbox from "../atoms/Lightbox";

export interface MenuCardProps {
  imgSrc: string;
  imgAlt: string;
  imgLightBox?: Array<string>;
  descDetails: MenuCardDescriptionProps[];
}

const MenuCard: React.FC<MenuCardProps> = ({
  imgSrc,
  imgAlt,
  descDetails,
  imgLightBox,
}) => {
  return (
    <div className="menu-card">
      <div className="menu-card-img">
        <span style={{ cursor: "pointer" }}>
          {!imgLightBox && (
            <img src={imgSrc} alt={imgAlt} width={85} height={85} />
          )}
          {imgLightBox && (
            <ImageLightbox
              images={imgLightBox}
              thumbnail={{ width: 85, height: 85 }}
            />
          )}
        </span>
      </div>
      <div className="menu-card-desc-block">
        {descDetails.map((desc, index) => (
          <MenuCardDescription key={index} title={desc.title} text={desc.text}>
            {desc.children}
          </MenuCardDescription>
        ))}
      </div>
    </div>
  );
};

export default MenuCard;
